import { useMediaQuery } from "@mui/material";
import { Box } from "@mui/system";
import AverageTokenUsage from "./AverageTokenUsage";
import AverageLatencyUsage from "./AverageLatencyUsage";
import { FC } from "react";
import { InsureAssistPerformanceStyles } from "./InsureAssistPerformanceStyles";
interface IIAPerformanceMetricsProps {
  tokenUsageData: any;
  latencyUsageData: any;
}
const IAPerformanceMetrics: FC<IIAPerformanceMetricsProps> = ({
  tokenUsageData,
  latencyUsageData,
}) => {
  const isMobile = useMediaQuery("(max-width:767px)");
  return (
    <Box
      sx={{
        ...InsureAssistPerformanceStyles.metricsContainer,
        maxWidth: isMobile ? "calc(100vw - 48px)" : "none",
        flexDirection: isMobile ? "column" : "row",
      }}
      id="ia_performance_metrics_container"
      data-test-id="ia_performance_metrics_container"
      aria-label="Insure Assist Performance Metrics"
    >
      <AverageTokenUsage tokenUsageData={tokenUsageData} />
      <AverageLatencyUsage latencyUsageData={latencyUsageData} />
    </Box>
  );
};

export default IAPerformanceMetrics;
